import { HISTORY_META_EDIT_SECTION } from '../../../../constants/changeHistory'

const getVerb = historyDescription => {
  // If there is an s on the end of the word then it should be were not was
  const hasSinEnd = historyDescription && historyDescription[historyDescription.length - 1] === 's'
  if (hasSinEnd && historyDescription !== 'status') {
    return 'were'
  } else {
    return 'was'
  }
}
export const generateDetailsText = (item, itemLabel) => {
  const historyActionDescription = item.meta?.[HISTORY_META_EDIT_SECTION]?.toLowerCase() || ''

  // check last letter of historyActionDescription when it 's' then return 'were' else return 'was'
  const verb = getVerb(historyActionDescription)

  return `${itemLabel} ${historyActionDescription} ${verb} ${item.action}d by ${item.user?.username}`
}
